import { useContext } from 'react';
import {
    Table, TableBody, TableCell, Tooltip, Zoom,
    TableHead, TablePagination, TableRow, IconButton, TableFooter, Typography
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import { carriersContext } from '../CarriersContext';
import { CircleLoader } from 'components';
import { Link } from 'react-router-dom';

let Results = () => {
    let service = useContext(carriersContext);

    return (
        <div>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Code</TableCell>
                            <TableCell>Tracking url</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.carriers.length > 0 &&
                            service.carriers
                                .map((carrier, index) =>
                                    <TableRow hover key={index}>
                                        <TableCell>{carrier.carrierCode}</TableCell>
                                        <TableCell>{carrier.trackingUrl}</TableCell>
                                        <TableCell align="right">
                                            <Tooltip TransitionComponent={Zoom} title="Edit">
                                                <IconButton
                                                    color="primary"
                                                    size="small"
                                                    component={Link}
                                                    to={{
                                                        pathname: `/admin/carrier/edit/${carrier.id}`,
                                                    }}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip TransitionComponent={Zoom} title="Delete">
                                                <IconButton
                                                    color="secondary"
                                                    size="small"
                                                    onClick={() => service.deleteCarrier(carrier.id)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                )}
                    </TableBody>
                    {service.carriers.length === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={6}>
                                    <Typography variant="subtitle2">No carriers found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            }
            {service.isLoading === false &&
                <TablePagination
                    component="div"
                    count={service.recordCount}
                    onPageChange={service.handleChangePage}
                    page={service.search.pageNr}
                    rowsPerPage={service.search.pageSize}
                    rowsPerPageOptions={[service.search.pageSize]}
                />
            }
        </div>
    );
}

export default Results;